export function preventMinusCharacter(event) {
    if (!event) return
    if (event.key === "-" || event.key === "e") {
        event.preventDefault()
    }
    return event
}
